import { render, staticRenderFns } from "./SysDataSourceList.vue?vue&type=template&id=6326a0ea&scoped=true&"
import script from "./SysDataSourceList.vue?vue&type=script&lang=js&"
export * from "./SysDataSourceList.vue?vue&type=script&lang=js&"
import style0 from "./SysDataSourceList.vue?vue&type=style&index=0&id=6326a0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326a0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6326a0ea')) {
      api.createRecord('6326a0ea', component.options)
    } else {
      api.reload('6326a0ea', component.options)
    }
    module.hot.accept("./SysDataSourceList.vue?vue&type=template&id=6326a0ea&scoped=true&", function () {
      api.rerender('6326a0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysDataSourceList.vue"
export default component.exports